import React from 'react';
import { useSelector } from 'react-redux';

import PriceDetailsItem from './PriceDetailsItem';
import { selectCartCurrency, selectCartTotal } from '../selectors';

const PriceDetails = ({ children, showTotal = true }) => {
    const total = useSelector(selectCartTotal);
    const currency = useSelector(selectCartCurrency);
    return (
        <table className="table table-price">
            <tbody>
                {children}
                {showTotal && <PriceDetailsItem name="Total" price={total} currency={currency} styleClass="fw-bold" />}
            </tbody>
        </table>
    );
};
export default PriceDetails;
